import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import useEvent from "react-use-event-hook";

import {
  COURSES_CALENDAR_URL_PATH,
  CoursesRoutes,
  RoutePaths,
  usePrefixedRouting,
} from "@ryde/shared";

export const useCoursesNavigation = () => {
  const { navigatePrefixed } = usePrefixedRouting();
  const location = useLocation();

  const isCalendarCoursesView = useMemo(
    (): boolean =>
      location.pathname.includes(
        `${RoutePaths.COURSES}${COURSES_CALENDAR_URL_PATH}`,
      ),
    [location.pathname],
  );

  const navigateCoursesGrid = useEvent((keepQuery = true): void => {
    const queryString =
      location.pathname.includes(RoutePaths.COURSES) && keepQuery
        ? location.search || ""
        : "";
    navigatePrefixed(`${CoursesRoutes.SEARCH_GRID}${queryString}`);
  });

  const navigateCoursesCalendar = useEvent((keepQuery = true): void => {
    const queryString =
      location.pathname.includes(RoutePaths.COURSES) && keepQuery
        ? location.search || ""
        : "";
    navigatePrefixed(`${CoursesRoutes.SEARCH_CALENDAR}${queryString}`);
  });

  return {
    isCalendarCoursesView,
    navigateCoursesGrid,
    navigateCoursesCalendar,
  };
};
